import { render } from "./ApprovalsListCard.vue?vue&type=template&id=7365a5cf"
import script from "./ApprovalsListCard.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__